import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UsuarioService } from 'src/app/core/services/usuario/usuario.service';
declare var $: any;

@Component({
  selector: 'app-preguntas',
  templateUrl: './preguntas.component.html',
  styleUrls: ['./preguntas.component.scss']
})
export class PreguntasComponent implements OnInit {
  @Input() data;
  @Input() isRole = false;
  @Input() activityId;

  @Output() changeEmitter = new EventEmitter();


  constructor(private usuarioService: UsuarioService) {

  }
  ngOnInit(): void {
  }
  change() {
    this.changeEmitter.emit({ activity: this.activityId, instruction: this.data })
  }
  ngAfterContentInit() {
    $('.ui.selection.dropdown').dropdown();
  }

}
